<template lang="pug">
  .box
    .box-header.b-b
      h3 {{ trans('general.outlets') }}
      small Filter by {{ outlets }}
      
    .box-body
      div

        p(v-if="outletList.length === 0 && !loading") No {{ outlets }} available.

        multiselect(
          deselect-label=""
          label="name"
          :placeholder="`All ${outlets}`"
          select-label=""
          track-by="id"
          v-model="selectedOutletsMultiselect"
          :clear-on-select="false"
          :close-on-select="false"
          :hide-selected="true"
          :loading="loading"
          :multiple="true"
          :options="outletList"
          @search-change="refreshOutletList"
          @select="onOutlet"
          @remove="onRemoveOutlet"
          @close="$emit('close')"
        )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: Array,
            required: false,

            default() {
                return [];
            },
        },
    },

    data() {
        let outlets = this.trans('general.outlets').toLowerCase();

        return {
            selectedOutletsMultiselect: [],
            outlets,
        };
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),

        loading() {
            return this.onLoading('fetch-outlet');
        },

        selectedOutlets: {
            get() {
                return this.value;
            },

            set(value) {
                this.$emit('input', value);
            },
        },
    },

    mounted() {
        this.getOutletListIfNecessary();
    },

    methods: {
        ...mapActions('outlet', ['getOutletListIfNecessary']),

        refreshOutletList: _.debounce(function(query) {
            this.getOutletListIfNecessary({ query: query });
        }, 500),

        onOutlet(value) {
            this.value.push(value.id);
        },

        onRemoveOutlet(value) {
            const outlets = _.pull(this.value, value.id);
            this.$emit('input', outlets.map(r => r));
            this.$emit('remove');
        },
    },
};
</script>

<style lang="scss" scoped>
.box-body {
    p:last-child {
        margin-bottom: 0;
    }
}

.loading {
    line-height: 1;
    text-align: center;
}
</style>
